import useMapEnum from "src/functions/mappers/use-map-enum";
import { MaritalStatus_Enum } from "src/types/enums";

const maritalStatusOptions = useMapEnum(Object.values(MaritalStatus_Enum))

export default maritalStatusOptions;
